import React from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { color, size } from '../styles/helpers/variables';
import {
  DesignerCardRootContainer,
  DesignerCardContent,
  DesignerCardContentContainer,
  DesignerCardImageContainer,
  DesignerCardImage,
  DesignerCardHeading,
  DesignerCardBody
} from '../styles/blocks/DesignerCardBlock';

import { SITE_ROOT_URL } from '../constants/endpoints';

const AboutCard = props => {
  const { imageUrl, imageAlt, heading, body, linkText, linkUrl, defaultLinkText } = props;

  if (!imageUrl || !(heading || body)) {
    return false;
  }

  return (
    <DesignerCardRootContainer>
      <DesignerCardImageContainer>
        <DesignerCardImage src={SITE_ROOT_URL + imageUrl} alt={imageAlt} />
      </DesignerCardImageContainer>
      <DesignerCardContent>
        <DesignerCardContentContainer>
          <DesignerCardHeading>{heading}</DesignerCardHeading>

          <DesignerCardBody>
            <Truncate lines={7}>{body}</Truncate>
          </DesignerCardBody>

          <ButtonLinkContainer>
            <ButtonLink to={linkUrl}>{linkText || defaultLinkText}</ButtonLink>
          </ButtonLinkContainer>
        </DesignerCardContentContainer>
      </DesignerCardContent>
    </DesignerCardRootContainer>
  );
};

const ButtonLinkContainer = styled.div`
  text-align: center;
`;
const ButtonLink = styled(Link)`
  display: inline-block;
  padding: 17.5px 40px;
  border-top: 1px solid ${color.black};
  border-bottom: 1px solid ${color.black};
  color: ${color.black};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  letter-spacing: 0.125em;
  line-height: 1.25;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  @media screen and (min-width: ${size.xXLarge}px) {
    padding: 17.5px 60px;
  }
  &:hover {
    background-color: ${color.black};
    color: ${color.white};
  }
`;

AboutCard.defaultProps = {
  imageUrl: null,
  imageAlt: null,
  heading: null,
  body: null,
  linkText: null,
  linkUrl: null,
  defaultLinkText: null
};

AboutCard.propTypes = {
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  defaultLinkText: PropTypes.string
};

export default AboutCard;



// WEBPACK FOOTER //
// ./src/components/AboutCard.js